const htmlTag = document.documentElement,
      inMicrosite = htmlTag.dataset.inMicrosite;

IB.is_in_microsite = (typeof inMicrosite != 'undefined' && inMicrosite.length && inMicrosite != 'false');
IB.current_microsite = IB.is_in_microsite ? inMicrosite : '';
